import app_config from '../../../config/app/config'
import { RecommendationAPI } from '../../../api/restApi'
import log from '../../../libs/log'
import { AppThunk } from '../../../model/model'
import { dataLoadedFail } from '../../app/actions'
import { customerIdSelector, eventIdSelector, languageSelector } from '../../app/selectors'
import { tokenSelector } from '../../auth/selectors'
import { brandsSelector, subbrandToMainBrandMapSelector } from '../../brands/selectors'
import { customerTypeSelector } from '../../customer/selectors'
import { recommendedBrandLoadedSelector } from '../selectors'
import { slice } from '../slice'
import { setCart, saveUpdatedCart, getCart, loadMissingCartProductDetails } from './cartThunks'
import { setActiveBrandAction } from './brandActions'
import { updateAnalytics } from './analytics'
import {
  getRecommendationCategories,
  subBrandToCategoryIdCompleteCart,
} from '../../../libs/couvettes'
import { subscribeToCartMessagesAction } from './subscriptions'
import { getCartCached, updateCartAction } from './updateCart'

export { updateCartAction, subscribeToCartMessagesAction, getCartCached }
export { getCart, loadMissingCartProductDetails }

/* METHODS */

export const getCartRecommendedAction = (activeBrand: string, category: string): AppThunk => {
  return (dispatch, getState) => {
    const state = getState()
    const token = tokenSelector(state)
    const customerId = customerIdSelector(state)
    const lang = languageSelector(state)
    const eventId = eventIdSelector(state)
    const brands = brandsSelector(state)
    const subbrandToMainBrandMap = subbrandToMainBrandMapSelector(state)
    const customerType = customerTypeSelector(state)
    const recommendedBrandsLoaded = recommendedBrandLoadedSelector(state)

    if (
      !customerId ||
      !eventId ||
      !token ||
      recommendedBrandsLoaded.includes(`${activeBrand}-${category}`) ||
      recommendedBrandsLoaded.includes(`${subbrandToMainBrandMap[activeBrand]}-${category}`)
    ) {
      return
    }

    const brand = brands.find(brand => brand.code === subbrandToMainBrandMap[activeBrand])
    const brandsQueryParam = brand
      ? brand.subBrands
          .filter(subBrand => {
            const subBrandCat = subBrandToCategoryIdCompleteCart(subBrand, category)
            return (
              subBrandCat &&
              (subBrandCat === category ||
                app_config.opticalCategories.includes(subBrandCat) ||
                app_config.sunCategories.includes(subBrandCat))
            )
          })
          .map(({ code }) => code) || activeBrand
      : [activeBrand]

    const cartSection = 'recommendation'
    dispatch(slice.actions.loadingCartSection(cartSection))

    const api = new RecommendationAPI(token, lang)
    api
      .get({
        customerId,
        eventId,
        brand: brandsQueryParam.join(','),
        customerType,
        category: getRecommendationCategories(category),
        brandParent: activeBrand,
      })
      .then(recommendations => {
        if (!recommendations) return
        dispatch(
          slice.actions.loadRecommended({
            recommendation: recommendations,
            brand: activeBrand,
            category,
          }),
        )
      })
      .catch(err => {
        log.error(err, 'getRecommendation')
        return dispatch(dataLoadedFail(err))
      })
  }
}

export const setCartProductsDetailsLoaded = slice.actions.setCartProductsDetailsLoaded
export const setLastAddedProductRecap = slice.actions.setLastAddedProductRecap
export const setCartUpdating = slice.actions.setCartUpdating
export const resetRecommended = slice.actions.resetRecommended
export const loadRecommended = slice.actions.loadRecommended
export const toggleCategoryAssortment = slice.actions.toggleCategoryAssortment
export const changeAssortmentViewType = slice.actions.changeAssortmentViewType
export const switchCartType = slice.actions.switchCartType
export const resetCartView = slice.actions.resetCartView
export const saveCartProductsDetails = slice.actions.saveCartProductsDetails
export const setAnalytics = slice.actions.setAnalytics
export const setCartViewType = slice.actions.setCartViewType
export const setMyShopActiveTab = slice.actions.setMyShopActiveTab
export const toggleMyShopAssortmentCollapse = slice.actions.toggleMyShopAssortmentCollapse
export const setWaitingApiRequestAsPending = slice.actions.setWaitingApiRequestAsPending
export const resetPendingApiRequestAsWaiting = slice.actions.resetPendingApiRequestAsWaiting
export const loadCart = slice.actions.loadCart
export const addToApiRequestBuffer = slice.actions.addToApiRequestBuffer
export const setActiveBrandCodeAction = slice.actions.setActiveBrandCodeAction
export const setPendingApiRequestAsFullfilled = slice.actions.setPendingApiRequestAsFullfilled
export const setMyShopLastAddedProductUpcs = slice.actions.setMyShopLastAddedProductUpcs

const cartActions = {
  ...slice.actions,
  setCart,
  getCart,
  updateAnalytics,
  loadMissingCartProductDetails,
  getCartRecommendedAction,
  setActiveBrandAction,
  saveUpdatedCart,
}

export default cartActions
